import classNames from 'classnames/bind';
import styles from './Options.module.css';

import { Controller, useFormContext } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { useAppSelector } from '../../../../../hooks/useRedux';
import { selectMenu } from '../../../../../features/infoSlice';

import Input from '../../../../Input';
import {
  LINK_EXPIRATION_DATE,
  LINK_PWD,
  NOTE_DRAG_CAPTURE_RESTRICTION,
  PRINT_RESTRICTION,
} from '../../../../../constants';
import { addDays, formatDate } from '../../../../../utils/date';
import { isMobile } from '../../../../../utils/util';
import { useTranslation } from 'react-i18next';

interface Options {
  type: string;
  data: any;
  changeHandler: (e: React.FormEvent<HTMLLabelElement>) => void;
  setData: (id: string, key: string, val: any) => void;
  changePwd?: ({ target }: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function Options({
  type,
  data,
  changeHandler,
  setData,
  changePwd,
}: Options) {
  const cx = classNames.bind(styles);
  const { i18n } = useTranslation();
  const menu = useAppSelector(selectMenu);
  const { control, getValues } = useFormContext();
  const idPrefix = menu === 'library' && type ? `${type}.` : '';

  return (
    <>
      <div className={cx('share_date')}>
        <div className={cx('date')}>
          <label onChange={changeHandler}>
            <Input
              type="checkbox"
              id={`${idPrefix}expDateYn`}
              value={data?.expDateYn}
              isHidden={true}
            />
            <span className={cx('clabel')}>{LINK_EXPIRATION_DATE}</span>
          </label>
          <Controller
            control={control}
            name={`${idPrefix}expDate`}
            defaultValue={
              data?.expDate ? formatDate(data?.expDate.toString()) : ''
            }
            render={() => (
              <DatePicker
                className="datepicker-input"
                onChange={(date) => {
                  setData(
                    `${idPrefix}expDate`,
                    'expDate',
                    formatDate(date?.toString() ?? '')
                  );
                }}
                selected={
                  data?.expDateYn && getValues(`${idPrefix}expDate`)
                    ? new Date(getValues(`${idPrefix}expDate`))
                    : null
                }
                dateFormat={
                  i18n.language === 'ko-KR' ? 'yyyy.MM.dd' : 'MM/dd/yyyy'
                }
                minDate={new Date()}
                locale={i18n.language}
                placeholderText={LINK_EXPIRATION_DATE}
                disabled={!data?.expDateYn}
                showPopperArrow={false}
                maxDate={new Date(addDays(1, 'year').toString())}
                showDisabledMonthNavigation
                {...(isMobile && { popperPlacement: 'top-start' })}
              />
            )}
          ></Controller>
        </div>

        {type === 'shareLink' && (
          <div className={cx('date')}>
            <label onChange={changeHandler}>
              <Input
                type="checkbox"
                id={`${idPrefix}pwdYn`}
                value={data?.pwdYn}
                isHidden={true}
              />
              <span className={cx('clabel')}>{LINK_PWD}</span>
            </label>
            <Input
              type="password"
              classnames={['input_t', 'shared_pwd']}
              id={`${idPrefix}pwd`}
              value={data?.pwd}
              onChange={changePwd}
              placeholder={LINK_PWD}
              isDisabled={!data?.pwdYn}
            />
          </div>
        )}
      </div>

      {menu === 'library' && (
        <div className={cx('share_date', 'restrictions')}>
          <div>
            <label>
              <Input
                type="checkbox"
                id={`${idPrefix}printYn`}
                value={data?.printYn}
                isHidden={true}
              />
              <span className={cx('clabel')}>{PRINT_RESTRICTION}</span>
            </label>
          </div>
          <div>
            <label>
              <Input
                type="checkbox"
                id={`${idPrefix}captureYn`}
                value={data?.captureYn}
                isHidden={true}
              />
              <span className={cx('clabel')}>
                {NOTE_DRAG_CAPTURE_RESTRICTION}
              </span>
            </label>
          </div>
        </div>
      )}
    </>
  );
}
